import cx from "classnames";
import { areDatesEqualWithinTolerance, formatPitForDisplay } from "src/utils/time";
import RunStatusBar from "../RunsStatusBars/components/RunStatusBar/RunStatusBar";
import PitSubtitle from "./components/PitSubtitle/PitSubtitle";
import { TOLERANCE } from "./Pit.constants";
import type { PitProps } from "./Pit.types";

const Pit = ({
  className,
  app_pit,
  last_run,
  start_time,
  status,
  type = "pipeline",
  basic = false, // if true, only render the PIT itself without a subtitle
  onlySubtitle = false, // if true, only render the subtitle without the PIT itself (used for re-runs)
  slotProps,
}: PitProps) => {
  // if "onlySubtitle" is true, it is assumed that the PIT itself is not rendered, so no need to check if the dates are equal
  const equal = onlySubtitle
    ? false
    : areDatesEqualWithinTolerance(app_pit, last_run || start_time, TOLERANCE);

  const shouldRenderSubtitle = !basic && (last_run || start_time) && !equal;

  return (
    <div
      className={cx(
        "inline-grid grid-cols-[auto_1fr] gap-x-2 place-items-baseline",
        className
      )}
    >
      {status && (
        <RunStatusBar
          status={status}
          withTooltip
          className={cx({ "w-1! h-full!": type !== "task" })}
          variant={type === "task" ? "square" : "bar"}
        />
      )}
      <div className="flex flex-col min-w-0">
        {!onlySubtitle && (
          <div className="min-w-0 truncate" data-test-id="pit" data-value={app_pit}>
            {formatPitForDisplay(app_pit)}
          </div>
        )}
        {shouldRenderSubtitle && (
          <PitSubtitle
            tooltipTitle={slotProps?.PitSubtitle?.tooltipTitle}
            last_run={last_run}
            start_time={start_time}
            app_pit={app_pit}
          />
        )}
      </div>
    </div>
  );
};

export default Pit;
